module.exports = __webpack_public_path__ + "img/hero-image-00-no.4dfbfe22.png";